function extension(imageId) {
  if (imageId) {
    const id = imageId.toString().split('/');
    return id[2] ? id[2].replace('_fpx.tif', '') : '';
  }
  return '';
}

module.exports = extension;
